import { AnalysisProfileView } from '@/common/components/AnalysisProfileView';

const SECTIONS = [
  'WHAT HAPPENED',
  "WHAT'S COMING",
  'WHO YOU MEET WITH',
  'REGULAR RHYTHMS',
  'BIRTHDAYS & MILESTONES',
  'WHAT THIS REVEALS',
] as const;

export function CalendarProfileView() {
  return (
    <AnalysisProfileView
      title="Calendar Profile"
      apiBase="/integrations/calendar"
      sectionLabels={SECTIONS}
      analyzedCountSuffix="events analyzed"
      placeholderCopy="Click Generate above to produce a Calendar profile from your past and upcoming events."
    />
  );
}
